module.exports = __webpack_public_path__ + "static/media/Ministerio de economia y finanzas.f8428940.png";